import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EditorType } from 'src/model/card'
import CoverSuneditor from './landing-page-suneditor'
import DragDropEditor from './drag-drop-editor'
import { withStyles } from '@material-ui/core'
import styles from './styles'
const CoverText = props => {
  const { classes } = props
  const course = useSelector(state => state.course.course)
  const editorType = EditorType[course?.editorType]

  return (
    <div className={classes.container}>
      <DragDropEditor data={'cardData'} isLoading={false} />
    </div>
  )
}

export default withStyles(styles)(CoverText)
